// @flow

// Rather than plumbing the same tracking parameters through all PinRep,
// TrackingParametersContext provides them at the root PinRep level.

import createHydra from 'app/packages/createHydra';

export type TrackingParametersContextType = {|
  componentType?: $Values<PCONST.thrift.ComponentType>,
  contextLogData?: Object,
  impressionAuxFields?: Object,
  slotIndex: number,
  viewData?: {
    pin_id?: string,
  },
  viewParameter?: $Values<PCONST.thrift.ViewParameterType>,
  viewType?: $Values<PCONST.thrift.ViewType>,
|};

const {
  Provider: TrackingParametersContextProvider,
  Consumer: TrackingParametersContextConsumer,
  useHook: useTrackingParameters,
} = createHydra<TrackingParametersContextType>('trackingParametersContext');

export {
  TrackingParametersContextProvider,
  TrackingParametersContextConsumer,
  useTrackingParameters,
};
